














import {
  computed,
  defineComponent,
  reactive,
  SetupContext
} from "@vue/composition-api";

import { ThemProfPropsDef, ThemProfProps } from "@/models";
import SectionDefault from "./section-default.vue";

export default defineComponent({
  name: "SkillSet",
  components: { SectionDefault },
  props: {
    ...ThemProfProps
  },

  setup(props: ThemProfPropsDef, context: SetupContext) {
    return {};
  }
});
